import * as React from "react";

const SvgViant = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 192 192"
    {...{ ...props, ref }}
  >
    <path
      d="M0 96v96h192V0H0v96zm86.8-46.3.3 13.2-5.5.3-5.5.3 10.6 24.7c5.9 13.7 10.8 24.6 11 24.4.2-.2 4.4-11.4 9.2-25l8.8-24.6h-10.8l.3-13.3.3-13.2h55l.3 13.2.3 13.3h-7.8l-19.8 45.2c-10.9 24.9-20.3 45.9-20.8 46.6-1.3 1.7-32 1.7-33.5-.1-.6-.6-9.1-21.5-19-46.2l-18-45-5.6-.3-5.6-.3V50.1c0-7 .3-13.1.7-13.4.4-.4 12.8-.6 27.7-.5l27.1.3.3 13.2z"
      fill="red"
    />
  </svg>
);
export default React.forwardRef(SvgViant);
